/**
 * Error thrown when the portal iframe/embed fails to load or does not resolve to a webpage.
 * Platform adapters (e.g. Web SDK, React Native) should throw this when they detect load
 * failure so that integrators can catch it and handle appropriately (retry, fallback UI, etc.).
 */
import type { PortalLoadErrorReason } from "./protocol.js";

export class UserSoundPortalLoadError extends Error {
  readonly name = "UserSoundPortalLoadError";

  constructor(
    message: string,
    public readonly url?: string,
    public readonly reason?: PortalLoadErrorReason,
    public readonly statusCode?: number,
    public readonly cause?: unknown
  ) {
    super(message);
    Object.setPrototypeOf(this, UserSoundPortalLoadError.prototype);
  }

  /** Build a payload suitable for portal_load_error event (same shape as PortalLoadErrorEvent). */
  toEventPayload(): {
    eventType: "portal_load_error";
    url?: string;
    reason?: PortalLoadErrorReason;
    statusCode?: number;
    message?: string;
  } {
    return {
      eventType: "portal_load_error",
      url: this.url,
      reason: this.reason,
      statusCode: this.statusCode,
      message: this.message,
    };
  }
}
